import React from "react";
import Card from "react-bootstrap/Card";
import { Doughnut } from "react-chartjs-2";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

// 🔥 CENTER TEXT PLUGIN
const centerTextPlugin = {
  id: "centerText",
  beforeDraw(chart) {
    const { width, height } = chart;
    const ctx = chart.ctx;

    ctx.restore();

    ctx.font = "bold 22px sans-serif";
    ctx.fillStyle = "#555";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    ctx.fillText("68%", width / 2, height / 2 - 5);

    ctx.font = "12px sans-serif";
    ctx.fillStyle = "#999";
    ctx.fillText("Completed", width / 2, height / 2 + 15);

    ctx.save();
  },
};

function TaskProgressChart({ chartData }) {

  const data = {
    labels: chartData.labels,
    datasets: [
      {
        data: chartData.datasets[0].data,
        backgroundColor: chartData.datasets[0].backgroundColor,
        borderWidth: 0,
        cutout: "75%",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
    },
  };

  return (
    <Card className="p-3 border-0 shadow-sm rounded-4">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="fw-bold mb-0">Task</h6>

        <select className="form-select form-select-sm w-auto">
          <option>Office Management App</option>
        </select>
      </div>

      {/* CONTENT */}
      <div className="d-flex align-items-center justify-content-between">

        {/* CHART */}
        <div style={{ width: "180px", height: "200px" }}>
          <Doughnut
            data={data}
            options={options}
            plugins={[centerTextPlugin]}
          />
        </div>

        {/* LEGEND */}
        <div className="ms-3 small">

          <div className="d-flex align-items-center mb-2">
            <span className="bg-warning rounded-circle d-inline-block me-2" style={{width:10,height:10}}></span>
            In Progress <span className="ms-2 text-muted">30%</span>
          </div>

          <div className="d-flex align-items-center mb-2">
            <span className="bg-primary rounded-circle d-inline-block me-2" style={{width:10,height:10}}></span>
            Pending <span className="ms-2 text-muted">20%</span>
          </div>

          <div className="d-flex align-items-center mb-2">
            <span className="rounded-circle d-inline-block me-2" style={{width:10,height:10, background:"#9b59b6"}}></span>
            On Hold <span className="ms-2 text-muted">20%</span>
          </div>

          <div className="d-flex align-items-center">
            <span className="bg-success rounded-circle d-inline-block me-2" style={{width:10,height:10}}></span>
            Completed <span className="ms-2 text-muted">30%</span>
          </div>

        </div>

      </div>

    </Card>
  );
}

export default TaskProgressChart;